module.exports = __webpack_public_path__ + "static/media/icon-jpg.0d2ab7a0.svg";